export const getUploadImageFromCustomCompletePage = (value?: string | null) => {
  if (!value) return
  const match = value.match(/@upload\[(.*?)\]/)
  return match?.[1]
}
